import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import LearningCollectionEditStore from '../../../Edit/Store';
import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';

interface Props {
  store: LearningCollectionEditStore;
  disabled: boolean;
}

function BrowseAllButton({ store, disabled }: Props) {
  return (
    <li className={clsx('mt-4', disabled ? 'pointer-events-none' : '')}>
      <button onClick={store.addBrowseAll} className="w-full text-left">
        <div className={clsx('font-bold', disabled ? 'text-gray-300' : '')}>
          {when(equals(true), disabled)
            .map(() => <T kind="Add the ExecOnline Essentials catalog [already included]" />)
            .getOrElse(() => (
              <T kind="Add the ExecOnline Essentials catalog" />
            ))}
        </div>
        <div className={clsx(disabled ? 'text-gray-300' : '')}>
          <T kind="Collection participants can browse..." />
        </div>
      </button>
    </li>
  );
}

export default observer(BrowseAllButton);
